import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Bot, ArrowRight } from "lucide-react";
import { currency } from "../lib/format";

export default function RobotSnacksBanner() {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/robot-snacks/current").then((r) => setData(r.data)).catch(() => {});
    }, []);

    if (!data || !data.active) return null;
    const pct = Math.min(100, Math.round((data.funded_usd / data.ask.target_usd) * 100));

    return (
        <Link to="/robot-snacks" className="block" data-testid="robot-snacks-banner">
            <div className="card-warm rounded-2xl p-5 lg:p-6 grid sm:grid-cols-[auto_1fr_auto] gap-5 items-center hover:border-[var(--rl-primary)] transition-colors">
                <div className="w-12 h-12 rounded-full bg-[var(--rl-primary)] text-white flex items-center justify-center shrink-0">
                    <Bot className="w-6 h-6" />
                </div>
                <div className="min-w-0">
                    <div className="flex items-baseline gap-2 flex-wrap">
                        <div className="font-serif text-xl">Robot Snacks</div>
                        <span className="eyebrow text-[var(--rl-primary)]">{data.ask.reason}</span>
                    </div>
                    <div className="text-sm text-[var(--rl-text-2)] mt-1 line-clamp-1">
                        Keep the AI matchmaking, translation, and rescue analysis running — {currency(data.funded_usd)} of {currency(data.ask.target_usd)} snacked so far.
                    </div>
                    <div className="mt-2 h-1.5 rounded-full bg-[var(--rl-cream)] overflow-hidden">
                        <div className="h-full bg-[var(--rl-primary)]" style={{ width: `${pct}%` }} />
                    </div>
                </div>
                <span className="text-sm font-semibold text-[var(--rl-primary)] inline-flex items-center gap-1 shrink-0">
                    Feed the robot <ArrowRight className="w-4 h-4" />
                </span>
            </div>
        </Link>
    );
}
